import { createSelector } from 'reselect'
import { RootState } from '../types'
import { createEnum, IEnum } from '../../utils/createEnum'

export const fiatsSelector = (state: RootState): string[] => state.fiat.data

export const fiatsByQuerySelector = (query: string): ((state: RootState) => string[]) =>
  createSelector(fiatsSelector, (fiats): string[] => {
    const q = (query || '').toLowerCase()
    return fiats.filter((c) => c.toLowerCase().includes(q))
  })

export const fiatsEnumSelector = createSelector(fiatsSelector, (fiats): IEnum[] => createEnum(fiats))

export const fiatsEnumByQuerySelector = (query: string): ((state: RootState) => IEnum[]) =>
  createSelector(fiatsByQuerySelector(query), (fiats): IEnum[] => createEnum(fiats))
